import { render } from "./Rfv.vue?vue&type=template&id=b44cece6"
import script from "./Rfv.vue?vue&type=script&lang=js"
export * from "./Rfv.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__